module.exports = __webpack_public_path__ + "img/lenovo.f3c040c6.jpg";